module.exports = __webpack_public_path__ + "img/1img_page-0001.0a24ae9b.jpg";